import { render, staticRenderFns } from "./BaseDeleteIcon.vue?vue&type=template&id=3b855676&scoped=true"
import script from "./BaseDeleteIcon.vue?vue&type=script&lang=js"
export * from "./BaseDeleteIcon.vue?vue&type=script&lang=js"
import style0 from "./BaseDeleteIcon.vue?vue&type=style&index=0&id=3b855676&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b855676",
  null
  
)

/* custom blocks */
import block0 from "./BaseDeleteIcon.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports